import { useState } from 'react';
import { ButtonLoader } from '../ui';

export const PasswordResetForm = ({ onSubmit, isLoading = false }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ newPassword, confirmPassword });
  };

  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <div>
        <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700 mb-2">
          Nouveau mot de passe
        </label>
        <input
          id="newPassword"
          type="password"
          placeholder="Nouveau mot de passe"
          autoComplete="new-password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="w-full rounded-xl border border-[#00a389] bg-white px-4 py-3 text-base text-gray-800 placeholder:text-gray-400 shadow-sm transition focus:border-[#00967d] focus:outline-none focus:ring-2 focus:ring-[#00a389]/50"
          required
          disabled={isLoading}
          minLength={8}
        />
      </div>

      <div>
        <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-2">
          Confirmer le mot de passe
        </label>
        <input
          id="confirmPassword"
          type="password"
          placeholder="Confirmer le mot de passe"
          autoComplete="new-password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="w-full rounded-xl border border-[#00a389] bg-white px-4 py-3 text-base text-gray-800 placeholder:text-gray-400 shadow-sm transition focus:border-[#00967d] focus:outline-none focus:ring-2 focus:ring-[#00a389]/50"
          required
          disabled={isLoading}
          minLength={8}
        />
      </div>

      <button
        type="submit"
        disabled={isLoading}
        className="w-full rounded-xl bg-[#00a389] py-3 text-lg font-semibold text-white shadow-[0_12px_24px_rgba(0,163,137,0.25)] transition hover:bg-[#00967d] disabled:cursor-not-allowed disabled:bg-[#9bd9ce]"
      >
        {isLoading ? <ButtonLoader label="Réinitialisation en cours..." /> : 'Réinitialiser le mot de passe'}
      </button>
    </form>
  );
};
